import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { validationSchema } from '../validationSchema';
import { TManagersAndRepresentatives } from '../types';
import { getInitialValues } from '../utils';
import { useMemo } from 'react';
import {
  selectIsReidentification,
  selectManagersAndRepresentatives,
  selectManagmentStructure,
} from '~/store/identification-form/selectors';

export const useManagersAndRepresentativesForm = () => {
  const formData = useSelector(selectManagersAndRepresentatives);
  const { isAccountHolder } = useSelector(selectManagmentStructure) || {};
  const isReidentification = useSelector(selectIsReidentification);

  const initialValues = useMemo(
    () => getInitialValues(formData as TManagersAndRepresentatives),
    []
  );

  const form = useForm({
    resolver: yupResolver(
      validationSchema({ isAccountHolder: !!isAccountHolder, isReidentification })
    ) as unknown as Resolver<TManagersAndRepresentatives>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: initialValues,
  });

  return form;
};
